"use client";

import { c as _c } from "react/compiler-runtime";
import { logout, setLoading, setUser } from "@/redux/auth/authSlice";
import { useSession } from "next-auth/react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
const AuthProvider = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const {
    data: session,
    status
  } = useSession();
  const dispatch = useDispatch();
  let t1;
  let t2;
  if ($[0] !== dispatch || $[1] !== session || $[2] !== status) {
    t1 = () => {
      if (status === "loading") {
        dispatch(setLoading(true));
        return;
      }
      if (session?.user) {
        dispatch(setUser(session.user));
      } else {
        dispatch(logout());
      }
    };
    t2 = [session, status, dispatch];
    $[0] = dispatch;
    $[1] = session;
    $[2] = status;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== children) {
    t3 = <>{children}</>;
    $[5] = children;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default AuthProvider;